import Preview from '@apps/truevail/admin/components/preview'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Social Batches)',
  collection: {
    endpoint: `/api/admin/truevail/agency/advisors/${props.advisor.id}/social_batches`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Social Batch)', key: 'social_batch.title', sort: 'title' },
      { label: 't(Preview)', key: 'preview_status', collapsing: true, align: 'center', format: (publishing) => (
        <StatusToken status={ publishing.preview_status } />
      ) }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'messages_square',
      title: 't(No Social Batches)',
      text: 't(There are no social batches for this advisor)'
    },
    entity: 'social batch',
    recordTasks: (record) => [
      {
        label: 't(Send Preview)',
        svg: 'mail',
        modal: <Preview publishing={ record } scope="agency" type="social" />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
